/**
 * Cache validasi token antar mount UserRoute/AdminRoute.
 * Tanpa ini, tiap pindah /template ↔ /admin me-remount route guard
 * dan menampilkan spinner full-screen lagi.
 */

let routeAuthValidated = false;

export function isRouteAuthValidated() {
  return routeAuthValidated;
}

export function setRouteAuthValidated(value) {
  routeAuthValidated = !!value;
}

export function clearRouteAuthCache() {
  routeAuthValidated = false;
}
